import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import primitive_colors from "./primitive_colors";
import '../scss/vuetify/overrides.scss';
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';

import {nl, en} from 'vuetify/locale';

const defaults = {
  global: { baseColor: 'primary' },
  VSwitch: { baseColor: primitive_colors['neutral-400'], color: primitive_colors['system-success'] },
  VDialog: { persistent: true },
  VBtn: { baseColor: null },
  VListItem: { baseColor: null },
  VDataTable: {
    headerProps: {
      class: 'sm-bold',
      style: 'color: #8A94A6;'
    }
  },
  VContainer: {
    style: {
      backgroundColor: primitive_colors['neutral-200']
    }
  }
};

export default createVuetify({
  components,
  directives,
  defaults,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          ...primitive_colors,
          alternative: primitive_colors['neutral-100'],
          secondary: primitive_colors['neutral-200'],
          success: primitive_colors['system-success'],
          error: primitive_colors['system-error'],
          page: primitive_colors['gold-100'],
          selected: primitive_colors['gold-100'],
          active: primitive_colors['gold-200'],
          textSecondary: primitive_colors['gold-300'],
          border: primitive_colors['gold-400'],
          primary: primitive_colors['gold-500'],
          hover: primitive_colors['gold-700'],
          icon: primitive_colors['gold-800'],
          textPrimary: primitive_colors['gold-1000'],
        },
      },
    },
  },
  locale: {
    locale: 'nl',
    fallbackLocale: 'en',
    messages: {
      nl,
      en,
    },
  },
});
